import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import BoxDelete from './form/boxDelete/BoxDelete'
import BoxQrGet from './actions/boxQr/BoxQrGet'
import BoxFilesGet from './actions/BoxFiles/BoxFilesGet'

const PackBoxItem = ({ packId, box }) => {
  return (
    <TableRow>
        <TableCell align='center'>
            {box.id}
        </TableCell>
        <TableCell align='center'>
            <Link
                to={`/production/packs/${packId}/boxes/${box.id}`}
            >
                Коробка № {box.number}
            </Link>
        </TableCell>
        <TableCell align='center' className='myTable__actions'>
            <BoxQrGet 
                boxId={box.id}
            />
            <BoxFilesGet 
                boxId={box.id}
            />
            {/* <BoxDelete 
                boxId={box.id}
            /> */}
        </TableCell>
    </TableRow>
  )
}

export default PackBoxItem